module.exports = __webpack_public_path__ + "static/media/TemplateSendingCode.4abcb5fb.xlsx";